import { Skeleton } from "@/components/ui/skeleton";

export function PropertyDetailSkeleton() {
  return (
    <div
      aria-busy="true"
      aria-label="Đang tải bất động sản"
      className="flex flex-col gap-4 sm:gap-6"
    >
      {/* Breadcrumb */}
      <Skeleton className="h-4 w-32" />

      {/* Mobile: stacked. Desktop: 2-col layout */}
      <div className="grid gap-4 md:grid-cols-3 md:gap-6">
        <div className="flex flex-col gap-3 md:col-span-2">
          {/* Hero */}
          <Skeleton className="aspect-[16/9] w-full rounded-xl" />
          {/* Thumb strip */}
          <div className="flex gap-2">
            {Array.from({ length: 5 }).map((_, i) => (
              <Skeleton key={i} className="aspect-[4/3] w-24 rounded-md" />
            ))}
          </div>
          {/* Description */}
          <div className="space-y-2 pt-3">
            <Skeleton className="h-4 w-1/3" />
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-2/3" />
          </div>
        </div>

        <div className="flex flex-col gap-4">
          <Skeleton className="h-7 w-2/3" />
          <Skeleton className="h-5 w-1/3" />
          <Skeleton className="h-8 w-1/2" />
          <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-2">
            {Array.from({ length: 6 }).map((_, i) => (
              <Skeleton key={i} className="h-16 w-full rounded-lg" />
            ))}
          </div>
          <Skeleton className="h-11 w-full" />
        </div>
      </div>
    </div>
  );
}
